import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Link,
  useTheme,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Drawer,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import LogoImage from '../assets/logo.avif';

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const WixNavigationBar = (props: Props) => {
  const { window } = props;
  const theme = useTheme();
  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingY: '8px', paddingX: '32px' }}>
        <Box component="img" src={LogoImage} width="100%" sx={{ objectFit: 'cover' }} />
      </Box>
      <Divider />
      <List>
        <ListItem disablePadding>
          <Link
            href="https://www.findtemp.in.th/"
            underline="none"
            color={theme.palette.text.primary}
            sx={{ width: '100%' }}
          >
            <ListItemButton>
              <ListItemText primary={'หน้าหลัก'} />
            </ListItemButton>
          </Link>
        </ListItem>
        <ListItem disablePadding>
          <Link
            href="https://www.findtemp.in.th/our-service"
            underline="none"
            color={theme.palette.text.primary}
            sx={{ width: '100%' }}
          >
            <ListItemButton>
              <ListItemText primary={'บริการของเรา'} />
            </ListItemButton>
          </Link>
        </ListItem>
        <ListItem disablePadding>
          <Link
            href="https://www.findtemp.in.th/blog"
            underline="none"
            color={theme.palette.text.primary}
            sx={{ width: '100%' }}
          >
            <ListItemButton>
              <ListItemText primary={'บทความข่าวสาร'} />
            </ListItemButton>
          </Link>
        </ListItem>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, padding: 2, marginTop: 2 }}>
          <Button variant="outlined" onClick={() => navigate('/auth/sign_in')}>
            เข้าสู่ระบบ
          </Button>
          <Button variant="contained" LinkComponent={Link} href="https://line.me/R/ti/p/%40969xdkze" target="_blank">
            สอบถามรายละเอียด
          </Button>
        </Box>
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ width: '100%' }}>
      <AppBar position="relative" elevation={0} sx={{ backgroundColor: 'transparent' }}>
        <Toolbar
          sx={{
            width: '100%',
            margin: '0 auto',
            padding: '0 !important',
            display: 'flex',
            justifyContent: { xs: 'space-between', md: 'space-between' },
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box component="img" src={LogoImage} width="100%" sx={{ objectFit: 'cover' }} />
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2, alignItems: 'center' }}>
            <Link href="https://www.findtemp.in.th/" underline="none" color={theme.palette.text.primary}>
              หน้าหลัก
            </Link>
            <Link href="https://www.findtemp.in.th/our-service" underline="none" color={theme.palette.text.primary}>
              บริการของเรา
            </Link>
            <Link href="https://www.findtemp.in.th/blog" underline="none" color={theme.palette.text.primary}>
              บทความข่าวสาร
            </Link>
          </Box>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            <Button variant="contained" onClick={() => navigate('/auth/sign_in')}>
              เข้าสู่ระบบ
            </Button>
            <Button variant="contained" LinkComponent={Link} href="https://line.me/R/ti/p/%40969xdkze" target="_blank">
              สอบถามรายละเอียด
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            'display': { sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
};

export default WixNavigationBar;
